// extracted by mini-css-extract-plugin
export var deleteIcon = "_nx-5";
export var deleteOption = "_nx-3";
export var divider = "_nx-2";
export var downloadIcon = "_nx-4";
export var drawer = "_nx-0";
export var drawerFooter = "_nx-6";
export var drawerOpen = "_nx-1";
export var highlighted = "_nx-7";
export var lighterHighlight = "_nx-8";